export default {"src":"/_next/static/media/dotsRight.0d99810f.svg","height":349,"width":339,"blurWidth":0,"blurHeight":0};